import { useQuery } from '@tanstack/react-query';
import { Endpoint } from '@/Config/api/endpoint';
import { ConversationApi } from '@/Domain/api/Conversation/Conversation.api';

export const useGetConversation = (conversationId: string) => {
  const { data, isLoading, isFetching, isPending, isError, refetch } = useQuery({
    queryKey: [Endpoint.conversation.get, conversationId],
    queryFn: () => ConversationApi.get(conversationId),
    enabled: Boolean(conversationId),
    staleTime: 0,
  });

  return {
    conversation: data,
    isLoading,
    // A deleted or cross-scenario conversation never yields data, so callers that must not block
    // forever need "the request finished", not "the data arrived".
    isSettled: !isPending && !isFetching,
    // A failed refetch keeps the previous data under the app-wide gcTime: Infinity, so callers
    // that must not act on an obsolete row need the current request's outcome as well.
    isError,
    refetch,
  };
};
